import React from 'react'
import dasherize from '@/util/dasherize'
import groupBy from '@/util/groupBy'

const ProcessData = (data, context = 'pregunta') => {
  const {
    senadores,
    senadoresEnEjercicio,
    diputados,
    preguntas,
    respuestasDiputados,
    respuestasSenadores,
    respuestasSenadoresEnEjercicio,
  } = data

  const respuestasSenadoresPorNombre = groupBy(
    respuestasSenadores.nodes,
    'nombre',
  )
  const respuestasDiputadosPorNombre = groupBy(
    respuestasDiputados.nodes,
    'nombre',
  )
  const respuestasSenadoresEnEjercicioPorNombre = groupBy(
    respuestasSenadoresEnEjercicio.nodes,
    'nombre',
  )

  const senadoresQueRespondieron = []
  const senadoresQueNoRespondieron = []

  senadores.nodes.map(senador => {
    if (respuestasSenadoresPorNombre[senador.nombre]) {
      senadoresQueRespondieron.push({
        respuestas: respuestasSenadoresPorNombre[senador.nombre][0],
        ...senador,
        ...respuestasSenadoresPorNombre[senador.nombre][0],
      })
    } else {
      senadoresQueNoRespondieron.push({
        ...senador,
      })
    }
  })

  const senadoresEnEjercicioQueRespondieron = []
  const senadoresEnEjercicioQueNoRespondieron = []

  senadoresEnEjercicio.nodes.map(senador => {
    if (respuestasSenadoresEnEjercicioPorNombre[senador.nombre]) {
      senadoresEnEjercicioQueRespondieron.push({
        respuestas: respuestasSenadoresEnEjercicioPorNombre[senador.nombre][0],
        ...senador,
        ...respuestasSenadoresEnEjercicioPorNombre[senador.nombre][0],
      })
    } else {
      senadoresEnEjercicioQueNoRespondieron.push({
        ...senador,
      })
    }
  })

  const diputadosQueRespondieron = []
  const diputadosQueNoRespondieron = []

  diputados.nodes.map(diputado => {
    if (respuestasDiputadosPorNombre[diputado.nombre]) {
      diputadosQueRespondieron.push({
        respuestas: respuestasDiputadosPorNombre[diputado.nombre][0],
        ...diputado,
        ...respuestasDiputadosPorNombre[diputado.nombre][0],
      })
    } else {
      diputadosQueNoRespondieron.push({
        ...diputado,
      })
    }
  })

  const preguntasFormat = []

  preguntas.nodes.map(pregunta => {
    // console.log('pregunta', pregunta)
    // console.log('respuestasDiputados', respuestasDiputados.nodes)
    // console.log('diputadosQueRespondieron', diputadosQueRespondieron)
    // diputadosQueRespondieron
    // distrito: 1
    // fechaRespuestaCuestionario: "4/11/2021 11:36:14"
    // id: "87798240-5c67-5ad1-901a-c77df15128c7"
    // letralista: "AH"
    // lista: "Nuevo Pacto Social"
    // nivelEducacional: "Magister"
    // nombre: "Vlado Mirosevic Verdugo"
    // numerocandidato: 70
    // partidoPolitico: "Partido Liberal (PL)"
    // profesion: "Cientista político"
    // rangoDeEdad: "Menor a 40"
    // respuestas:
    // nombre: "Vlado Mirosevic Verdugo"
    // _1: "El aborto debe ser libre, seguro y gratuito."
    // _2: "Se debe refundar la institución de Carabineros, creando una nueva policía."
    // _3: "Se debe despenalizar el consumo y el porte de drogas como la marihuana y legalizar su producción, distribución y venta."
    // _4: "Sí, estoy de acuerdo con ambas demandas."
    // _5: "Se deben eliminar exenciones, reducir la evasión, e implementar un  impuesto a los super-ricos."
    // _6: "Se deben eliminar las AFP y crear un nuevo sistema público de seguridad social sin fines de lucro y con aportes tripartitos (empleador, trabajador/a y Estado)."
    // _7: "Se debe condonar esa deuda porque la educación debería ser siempre gratuita."
    // _8: "Se debe permitir el ingreso de migrantes pero frenar la inmigración ilegal y expulsar a quienes hubiesen ingresado de esta manera al país."
    // _9: "Se debe establecer un Plan de Salud Único de acceso universal y con un fondo único de financiamiento para todas las personas. Este plan podrá ser prestado por Fonasa, ISAPRES u otras aseguradoras."
    // _10: "Se debe impedir el desalojo de campamentos solo en casos específicos puesto que se debe resguardar tanto el derecho a la vivienda como el derecho a la propiedad."
    // _11: "El IFE debe terminar en diciembre pero hay que reforzar el IFE Laboral."
    // _12: "Adelantar el cronograma actual de retiro de centrales a carbón para que en el mediano plazo se retiren todas las centrales a carbón del sistema eléctrico."
    // _13: "Congreso unicameral: una sola Cámara."
    // _14: "Lo incluiría en la Constitución considerando el acceso, protección y distribución del recurso hídrico como un derecho fundamental, un bien nacional de uso público."
    // _15: "Se deben mantener los quórums supramayoritarios pero reduciendo su aplicación a pocas materias."
    // _16: "Se debe reformar el Estado unitario actual y pasar a un estado federal o regional donde hay un alto grado

    const alternativasPosiblesPorCampo = Object.keys(
      groupBy(
        [...respuestasDiputados.nodes, ...respuestasSenadores.nodes],
        pregunta.campoEnPlanilla,
      ),
    )
    // console.log('alternativasPosiblesPorCampo', alternativasPosiblesPorCampo)
    // campoEnPlanilla: "_16"
    // consideradaEnMapa: "sí"
    // enunciado: "<strong>Forma de Estado</strong> ¿Chile debe continuar siendo un Estado unitario como es actualmente o debería cambiar a otras formas de organización regional?"
    // id: "9abdfff9-a957-5359-9352-a87ebf81c3d3"
    // numero: 16
    // orden: "Se debe mantener el Estado unitario actual.-Se debe mantener el Estado unitario actual, pero-Se debe reformar el Estado unitario actual y pasar a un estado federal"
    // slug: "Forma de Estado"
    // sobreEstaPregunta: "El Estado unitario establecido en Chile se caracter

    const alternativas = []

    alternativasPosiblesPorCampo.map(alternativa => {
      const diputadosCoincidentes = diputadosQueRespondieron.filter(
        diputado =>
          diputado.respuestas[pregunta.campoEnPlanilla] === alternativa,
      )
      const senadoresCoincidentes = senadoresQueRespondieron.filter(
        senador => senador.respuestas[pregunta.campoEnPlanilla] === alternativa,
      )
      const senadoresEnEjercicioCoincidentes =
        senadoresEnEjercicioQueRespondieron.filter(
          senador =>
            senador.respuestas[pregunta.campoEnPlanilla] === alternativa,
        )

      alternativas.push({
        enunciado_alternativa: alternativa,
        diputados: diputadosCoincidentes,
        senadores: senadoresCoincidentes,
        senadoresEnEjercicio: senadoresEnEjercicioCoincidentes,
      })
    })

    preguntasFormat.push({
      ...pregunta,
      alternativas,
    })
  })

  return {
    preguntas: [...preguntasFormat],
    elegidos: {
      diputados: [...diputadosQueRespondieron, ...diputadosQueNoRespondieron],
      senadores: [...senadoresQueRespondieron, ...senadoresQueNoRespondieron],
      senadoresEnEjercicio: [
        ...senadoresEnEjercicioQueRespondieron,
        ...senadoresEnEjercicioQueNoRespondieron,
      ],
    },
  }
}

export default ProcessData
